/* istanbul ignore file */
import React from 'react';
import { CREATE_INVOICE } from 'domain/finance/invoice/useInvoiceService';
import { useInvoiceUrl } from 'domain/finance/invoice/shared/useInvoiceRouting';
import { useAuthorization } from 'framework/authorization';
import { useFieldHelper } from 'framework/ui/field';
import { LinkButton } from 'framework/ui/ui-builder';

const CopyInvoiceButton = (props: { source?: string }) => {
  const { getCopyEntityUrl } = useInvoiceUrl();
  const { getValue: getId } = useFieldHelper(props);
  const id = getId();
  const { isGranted } = useAuthorization();

  return isGranted(CREATE_INVOICE) ? (
    <LinkButton variant="outlined" {...props} url={getCopyEntityUrl(id)}>
      Copy
    </LinkButton>
  ) : null;
};

export default CopyInvoiceButton;
